import { render, staticRenderFns } from "./PercursoUfFilterBar.vue?vue&type=template&id=01ba5608"
import script from "./PercursoUfFilterBar.vue?vue&type=script&lang=js"
export * from "./PercursoUfFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports